import { useEffect, useRef } from "react";
import './header.component.css';
import jQuery from '../../../js/jquery.js';
import { Link } from "react-router-dom";
import axios from "axios";


export function Header() {
    const headerEle = useRef();

	// useEffect(()=>{
	// 	let data = JSON.stringify({
    //         "collection": "sales",
    //         "database": "mongodbVSCodePlaygroundDB",
    //         "dataSource": "Cluster0",
    //         "projection": {
    //             "_id": 1
    //         }
    //     });
            
    //     let config = {
    //         method: 'post',
    //         url: 'https://data.mongodb-api.com/app/data-ctnsz/endpoint/data/v1/action/findOne',
    //         headers: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Request-Headers': '*',
    //         'Accept': 'application/ejson',
    //         'api-key': 'MVTo9oHeuLtfWNvwwHH8PDbFrUs9xaAECpEhKOIg5DlRjlDtRFy6lsIaAhDlfJno',
    //         },
    //         data: data
    //     };
            
    //     axios(config)
    //         .then(function (response) {
    //             alert(JSON.stringify(response.data));
    //         })
    //         .catch(function (error) {
    //             debugger;
    //             alert(error); //https://www.mongodb.com/languages/mern-stack-tutorial
    //         });
        
        
	// });

    function showMenu(){
       let classNamename = headerEle.current.className;
       if(classNamename.indexOf("nav-collapse")>-1){
        headerEle.current.className = "transparent-nav";
       }
       else {
        headerEle.current.className = "transparent-nav nav-collapse";
       } 
    }


    return (
        <>
            {/* Header */}
			<header id="header" ref={headerEle} className="transparent-nav">
				<div className="c-header-menu header-menu-drop"></div>
				<div className="c-header-menu">

				<div className="navbar-header">
					<div className="navbar-brand">
						<Link className="logo" href="index.html">
							<label className="title">VKC Trainings</label>
						</Link>
					</div>
					<button className="navbar-toggle" onClick={()=>{showMenu()}}>
						<div className="tel">
							<a href="tel:917989539705" className="a-tel">&#9742; +91 7989539705 / 040-48502351</a>
						</div>
						<span></span>
					</button>
				</div>
				<nav id="nav">
					<div className="tel-1">
						<a href="tel:917989539705" className="a-tel">&#9742; +91 7989539705 / 040-48502351</a>
					</div>
					<ul className="main-menu nav navbar-nav navbar-right navbar-extend d-inline">
						<li><Link to="/home">Home</Link></li>
						<li><Link to="/about">About</Link></li>
						<li><Link to="/courses">Courses</Link></li>
						<li><Link to="/blog">Blog</Link></li>
						<li><Link to="/contact">Contact</Link></li>
					</ul>
				</nav>

			</div>
		</header>
		{/* /Header */}
        </>
    )
}


